<template>
  <div class="container">
    <b-container fluid>

      <div v-if="!returnCompleted">

        <div class="alert alert-danger" v-if="error" v-html="this.errorMessage">
        </div>

        <b-overlay :show="loading">
          <b-form @submit="onSubmit1">

            <b-row>
              <b-col sm="2">
                <label for="input-ordernumber">Order number *</label>
              </b-col>
              <b-col sm="10">
                <b-form-input id="input-ordernumber" :disabled="form1.disableFields" size="sm" v-model="form1.orderNumber" type="text" required></b-form-input>
              </b-col>
            </b-row>

            <b-row class="pt-3">
              <b-col sm="2">
                <label for="input-email">Email *</label>
              </b-col>
              <b-col sm="10">
                <b-form-input id="input-email" :disabled="form1.disableFields" size="sm" v-model="form1.email" type="email" required></b-form-input>
                <span class="email-hint">
                  * Please enter your order number and the email provided during your purchase to begin
                </span>
              </b-col>
            </b-row>

            <b-row class="pt-3" v-if="!verificationPassed">
              <b-button type="submit" variant="primary" class="m-auto btn-pink">Next</b-button>
            </b-row>

          </b-form>

          <b-form @submit="onSubmit2" v-if="verificationPassed">
            <b-row class="pt-3">
              <b-col sm="12">
                <h3>Where to pickup</h3>
              </b-col>
              <b-col sm="2">
                <label for="input-name">Name *</label>
              </b-col>
              <b-col sm="10">
                <b-form-input id="input-name" size="sm" v-model="form2.senderName" type="text" maxlength="50" data-pattern="/.+/" required></b-form-input>
              </b-col>

              <b-col sm="2">
                <label for="input-address">Address *</label>
              </b-col>
              <b-col sm="10">
                <b-form-input id="input-address" size="sm" v-model="form2.senderAddress" type="text" maxlength="50" required></b-form-input>
              </b-col>

              <b-col sm="2">
                <label for="input-city">City *</label>
              </b-col>
              <b-col sm="10">
                <b-form-input id="input-city" size="sm" v-model="form2.senderCity" type="text" required></b-form-input>
              </b-col>

              <b-col sm="2">
                <label for="input-postalcode">Postal Code *</label>
              </b-col>
              <b-col sm="10">
                <b-form-input id="input-postalcode" size="sm" v-model="form2.senderPostalCode" type="text" maxlength="10" required></b-form-input>
              </b-col>

              <b-col sm="2">
                <label for="input-province">State</label>
              </b-col>
              <b-col sm="10">
                <b-form-input id="input-province" size="sm" v-model="form2.senderProvince" type="text" maxlength="2"></b-form-input>
              </b-col>

              <b-col sm="2">
                <label for="input-country">Country *</label>
              </b-col>
              <b-col sm="10">
                <b-form-input id="input-country" size="sm" v-model="form2.senderCountryCode" type="text" maxlength="2" required></b-form-input>
              </b-col>

              <b-col sm="2">
                <label for="input-senderemail">Email *</label>
              </b-col>
              <b-col sm="10">
                <b-form-input id="input-senderemail" size="sm" v-model="form2.senderEmail" type="email" maxlength="50" required></b-form-input>
              </b-col>

              <b-col sm="2">
                <label for="input-senderphone">Phone *</label>
              </b-col>
              <b-col sm="10">
                <b-form-input id="input-senderphone" size="sm" v-model="form2.senderPhone" type="tel" maxlength="25" required></b-form-input>
              </b-col>

              <b-col sm="12">
                <h3>When to pickup</h3>
              </b-col>
              <b-col sm="2">
                <label for="pickup-datepicker">Date *</label>
              </b-col>
              <b-col sm="10">
                <div>
                  <b-form-datepicker id="pickup-datepicker" :date-disabled-fn="dateDisabled" v-model="form2.pickupDate" locale="en" class="mb-2"></b-form-datepicker>
                </div>
              </b-col>

              <!-- <b-col sm="2">
                <label for="pickup-hoursrange">Hours range *</label>
              </b-col>
              <b-col sm="10">
                <div>
                  <b-form-select v-model="form2.selectedHoursRange" :options="hoursRange"></b-form-select>
                </div>
              </b-col> -->

              <b-col sm="12">
                <h3>How many parcels to pickup</h3>
              </b-col>
              <b-col sm="2">
                <label for="input-packages">Number of parcels *</label>
              </b-col>
              <b-col sm="10">
                <!-- <b-form-input id="input-packages" size="sm" v-model="form2.packages" type="number" required></b-form-input> -->
                <b-form-group label="">
                  <b-form-radio-group id="input-packages" v-model="form2.packages" name="radio-input-packages">
                    <b-form-radio value="1">1 parcel</b-form-radio>
                    <b-form-radio value="2">2 parcels</b-form-radio>
                    <b-form-radio value="3">3 parcels</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
              </b-col>

            </b-row>

            <b-row class="pt-3">
              <b-button type="submit" variant="primary" class="m-auto btn-pink">Confirm</b-button>
            </b-row>

          </b-form>
        </b-overlay>
      </div>

      <div v-if="returnCompleted">
        <b-jumbotron class="alert-success" header="Congrats!" lead="Your shipping return request has been submitted successfully!">
          <p>
            You will receive the labels to be applied to the {{form2.packages > 1 ? 'packages' : 'package'}} to the email address you have specified
            <br/>
            <b-icon icon="envelope"></b-icon> {{form2.senderEmail}}
          </p>

        </b-jumbotron>
        <b-jumbotron header="Summary" lead="">
          <p>
            <b-icon icon="geo-alt"></b-icon> {{form2.senderAddress}} - {{form2.senderCity}} - {{form2.senderPostalCode}} ({{form2.senderCountryCode}})<br/>
            <b-icon icon="calendar"></b-icon> {{formatDate(form2.pickupDate)}} <br/>
            <!-- <b-icon icon="clock"></b-icon> {{form2.selectedHoursRange == 'morning' ? '09:00 - 13:00' : '14:00 - 18:00'}} <br/> -->
            <b-icon icon="gift"></b-icon> {{form2.packages}} <br/>
          </p>
        </b-jumbotron>
      </div>

    </b-container>
  </div>
</template>

<script>

import axios from 'axios'

export default {
  name: 'ManebiForm',
  data() {
    return {
      limeUrl: 'https://lime.grupposinergia.net', // 'http://localhost:8090', // https://lime.grupposinergia.net
      token: null,
      loading: false,
      error: false,
      errorMessage: '',
      form1: {
        disableFields: false,
        email: '',
        orderNumber: ''
      },
      form2: {
        senderName: '',
        senderAddress: '',
        senderCity: '',
        senderPostalCode: '',
        senderProvince: '',
        senderCountryCode: '',
        senderEmail: '',
        senderPhone: '',
        packages: '1',
        pickupDate: this.nextBusinessDay(),
        // selectedHoursRange: 'morning',
      },
      hoursRange: [
        { value: 'morning', text: 'Morning (9:00 - 13:00)' },
        { value: 'afternoon', text: 'Afternoon (14:00 - 18:00)' },
      ],
      verificationPassed: false,
      gsOrder: null,
      returnGoObj: null,
      requestedReturns: null,
      returnCompleted: false
    }
  },
  mounted() {
    axios
      .post(this.limeUrl + '/api/login', {"email":"manebi@grupposinergia.com","password":"manebi_shopify@A£$QARW£<"})
      // .post(this.limeUrl + '/api/login', {"email":"staging@grupposinergia.com","password":"Pa$$woRd?123"})
      .then(response => (
          this.token = response.data.token
        )
      )
      .catch(() => {
        this.error = true
        this.errorMessage = 'Network Error, please try again later.'
      })
  },
  methods: {
    formatDate(date) {
      date = new Date(date)
      let day = date.getDate().toString();
      let month = (date.getMonth() + 1).toString();
      const year = date.getFullYear().toString();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return [year, month, day].join('-');
    },
    nextBusinessDay() {
      const date = new Date();
      let daysToIncrement = 0;

      switch(date.getDay())
      {
        // lunedì > mercoledì
        case 1:
        case 2:
        case 3:
          daysToIncrement = (date.getHours() < 15) ? 1 : 2;
          break;

        // giovedì
        case 4:
          daysToIncrement = (date.getHours() < 15) ? 1 : 4;
          break;

        // venerdì
        case 5:
          daysToIncrement = (date.getHours() < 15) ? 3 : 4;
          break;

        // sabato
        case 6:
          daysToIncrement = 3
          break;

        // domenica
        case 0:
          daysToIncrement = 2
          break;

        default:
          // nothing to do here.
          break;
      }

      date.setDate(date.getDate() + daysToIncrement);

      return date
    },
    dateDisabled(ymd, date) {

      const nextBusinessDay = this.nextBusinessDay();
      nextBusinessDay.setHours(0,0,0,0);

      const weekday = date.getDay()

      return weekday === 0 || weekday === 6 || date < nextBusinessDay
    },

    getRequestedReturns() {
      // pageNumber, data = []

      return axios.get(this.limeUrl + '/api/v2/returngo/rmas',
          {headers: {
              'Authorization': 'Bearer ' + this.token,
              'company-code': 'MB',
              'x-shop-name': 'manebi.myshopify.com',
              'x-rg-api-key': 'k3q9UyvdEI6M7SmEhDxoe48PFZ8ZgDFAaJLHyfZU'
              }
          })
        .then(RGOResult => {
          // console.log(RGOResult);
          return RGOResult.data.rmas
            // if (RGOResult.data.length < 1 ) return data
            // data.push(...RGOResult.data)
            // pageNumber += 1
            // return this.getRequestedReturns(pageNumber, data)
        })
        // .catch(error => {
        //   console.log(error)
        // })

    },
    onSubmit1(evt) {
      evt.preventDefault()
      this.error = false
      this.loading = true

      axios.get(
        this.limeUrl + '/api/v1/orders/' + this.form1.orderNumber + '?shipping_email=' + this.form1.email,
        {headers: { 'Authorization': 'Bearer ' + this.token, 'company-code':'MB' }}
      )
      .then((result) => {
        this.getRequestedReturns().then(data => {

          this.loading = true;

          this.requestedReturns = data;

          this.gsOrder = result.data;

          let RMAlreadyDone = false;

          this.requestedReturns.forEach(element => {

            if(element.order_name.includes('#')){
              if(element.order_name === '#'+this.form1.orderNumber)
                {
                  this.returnGoObj = element
                  RMAlreadyDone = true;
                }
            }
            else{
              if(element.order_name === this.form1.orderNumber)
              {
                this.returnGoObj = element
                RMAlreadyDone = true;
              }
            }

          });

          if(!RMAlreadyDone)
          {
            this.error = true
            this.errorMessage = 'Before continuing with the pickup shipment by the courier, you must make a return request at <a href="https://manebi.com/a/returns?order=' + this.form1.orderNumber + '&email=' + this.form1.email + '" target="_blank">this link</a>'
          }
          else
          {
            this.form1.disableFields = true
            this.verificationPassed = true
            this.form2.senderName = this.gsOrder.shipping_name
            this.form2.senderAddress = this.gsOrder.shipping_address
            this.form2.senderCity = this.gsOrder.shipping_city
            this.form2.senderPostalCode = this.gsOrder.shipping_postal_code
            this.form2.senderProvince = this.gsOrder.shipping_province
            this.form2.senderCountryCode = this.gsOrder.shipping_country_code
            this.form2.senderEmail = this.gsOrder.shipping_email
            this.form2.senderPhone = this.gsOrder.phone
          }

          this.loading = false

        })
        .finally(() => this.loading = false);

      })
      .catch(() => {
        this.error = true
        this.errorMessage = 'No order found with this Number & Email combination'
        this.loading = false
      })
      // .finally(() => this.loading = false);

    },
    onSubmit2(evt) {
      evt.preventDefault()
      this.error = false
      this.loading = true

      // CHECK FORM 2 DATA

      for (const [key, value] of Object.entries(this.form2)) {

        if(!value && key.toString() !== 'senderProvince') {
          this.error = true
          this.errorMessage = 'Please fill all mandatory fields'
          this.loading = false
          return
        }

        if(key.toString() === 'senderEmail') {

          const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          var validEmail = re.test(String(value).toLowerCase())

          if(!validEmail) {
            this.error = true
            this.errorMessage = 'Invalid email format'
            this.loading = false
            return
          }
        }

      }


      // SEND SHIPMENT TO GSPED

      let service = '0';

      switch (this.form2.senderCountryCode)
      {
        case 'IT':
          service = '0';
          break;

        case 'AT':
        case 'BE':
        case 'BG':
        case 'HR':
        case 'DK':
        case 'EE':
        case 'FI':
        case 'FR':
        case 'DE':
        case 'GR':
        case 'IE':
        case 'LV':
        case 'LI':
        case 'LT':
        case 'LU':
        case 'NO':
        case 'NL':
        case 'PL':
        case 'PT':
        case 'GB':
        case 'CZ':
        case 'RO':
        case 'SK':
        case 'SI':
        case 'ES':
        case 'SE':
        case 'CH':
        case 'HU':
          service = '8';
          break;

        default:
          service = '9';
          break;
      }

      const gspedObj = {
        corriere: '104',
        servizio: service,
        client_id: '15',
        ddt_alpha: this.form1.orderNumber,
        merce: 'SHOES AND CLOTHING',
        rcpt_addr: 'Via Adige, 13/c',
        rcpt_cap: '37060',
        rcpt_city: 'Nogarole Rocca',
        rcpt_contact: 'Magazzino',
        rcpt_country_code: 'IT',
        rcpt_name: 'Societe 23.3 srl (Manebi)',
        rcpt_prov: 'VR',
        rcpt_email: 'tracking@grupposinergia.com',
        rcpt_phone: '+390456351570',
        sender_addr: this.form2.senderAddress,
        sender_cap: this.form2.senderPostalCode,
        sender_city: this.form2.senderCity,
        sender_contact: this.form2.senderName,
        sender_country_code: this.form2.senderCountryCode,
        sender_name: this.form2.senderName,
        sender_prov: this.form2.senderProvince,
        sender_email: this.form2.senderEmail,
        sender_phone: this.form2.senderPhone,
        dropshipping: 1,
        flag_reso: 1,
        date_req_ritiro: this.formatDate(this.form2.pickupDate),
        opening_time: '09:00:00',
        closing_time: '18:00:00',
        // opening_time: this.form2.selectedHoursRange == 'morning' ? '09:00:00' : '14:00:00',
        // closing_time: this.form2.selectedHoursRange == 'morning' ? '13:00:00' : '18:00:00',
        valore: 0,
        valore_doganale: this.gsOrder.customs_value,
        peso: 0.5 * this.form2.packages,
        volume: 0.001 * this.form2.packages,
        colli: this.form2.packages
      };

      const gspedJson = JSON.stringify(gspedObj);
      // console.log(gspedJson)

      axios.post(
        'https://api.gsped.it/sinergia/shipment',
        gspedJson,
        {headers:{ 'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-API-KEY':'paQqRgAggiK3Zh18L0INn3A7Hr5HzXbe'
                  }
        },
      ).then((result) => {
        // console.log(result)
        /* TODO:
          - recupera LDV
          - invia via mail a cliente (che libreria?)
        */

        if( ! result.data.error )
        {
          const gspedData = result.data.id.toString() + '|' + result.data.num_spedizione.toString();

          const commentObj = {
            htmlText: 'GSPEDDATA: ' + gspedData
          };

          axios.post(
            this.limeUrl + '/api/v2/returngo/rmas/' + this.returnGoObj.rmaId + '/comment',
            commentObj,
            {headers: {
              'Authorization': 'Bearer ' + this.token,
              'company-code': 'MB',
              'x-shop-name': 'manebi.myshopify.com',
              'x-rg-api-key': 'k3q9UyvdEI6M7SmEhDxoe48PFZ8ZgDFAaJLHyfZU'
              }}
          ).then(() => {
            // console.log(RGOPostResult)

             var stateObj = {
              status: 'Received',
              rejectReason: ''
            };

            axios.put(
              this.limeUrl + '/api/v2/returngo/rmas/' + this.returnGoObj.rmaId + '/status/Received',
              JSON.stringify(stateObj),
              {headers: {
              'Authorization': 'Bearer ' + this.token,
              'company-code': 'MB',
              'x-shop-name': 'manebi.myshopify.com',
              'x-rg-api-key': 'k3q9UyvdEI6M7SmEhDxoe48PFZ8ZgDFAaJLHyfZU'
              }}
            ).then(() => {
              // console.log(RGOPutResult)
              this.returnCompleted = true
            })
            .catch(error => {
              this.error = true
              this.errorMessage = error
            })


          })
          .catch(error => {
            this.error = true
            this.errorMessage = error
          })

        }
        else
        {
          this.error = true
          this.errorMessage = "Wrong info of where to pickup, try to change them. If the problem persists, contact our customer service on +390456351556<br/>"+result.data.error
        }


      })
      .catch(() => {
        this.error = true
        this.errorMessage = "Wrong info of where to pickup, try to change them. If the problem persists, contact our customer service on +390456351556."
      })
      .finally(() => this.loading = false);

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
* {
  font-size: 18px;
}

h3 {
  margin: 20px 0 10px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.container {
  padding-bottom: 150px;
}
.btn-pink {
  background-color: #CBB7A2;
  border-color: #CBB7A2;
  &:hover,
  &:active,
  &:focus,
  &:focus-within {
    background-color: #CBB7A2 !important;
    border-color: #CBB7A2 !important;
  }
}
.alert-success {
  background-color: #CBB7A2;
  border-color: #CBB7A2;
  color: #ffffff;
}

.email-hint {
  float: left;
  font-weight: bold;
}
</style>
